module.exports = __webpack_public_path__ + "img/protected-bag-icon-3.6d97a0c8.svg";